var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "group",
    d: "M11.936,5.655A4.019,4.019,0,0,0,8.194,9.9a4.35,4.35,0,0,0,1.989,3.753l-1.373.618L5.159,15.92a.9.9,0,0,0-.529.874V20.7a.918.918,0,0,0,.82.952H18.442a.911.911,0,0,0,.847-.952v-3.91a.9.9,0,0,0-.529-.874l-3.52-1.647L13.778,13.6a4.37,4.37,0,0,0,1.9-3.7,4.019,4.019,0,0,0-3.743-4.247ZM5.9,7.149a2.92,2.92,0,0,0-2.13,1,3.817,3.817,0,0,0-.887,2.418A3.648,3.648,0,0,0,4.524,13.63l-4.1,1.852A.676.676,0,0,0,0,16.2V19.34c.022.416.244.766.661.772H3.387V16.793a2.156,2.156,0,0,1,1.244-1.954l2.725-1.26a2.6,2.6,0,0,0,.609-.489,5.818,5.818,0,0,1-.555-5.478A3.062,3.062,0,0,0,5.9,7.147Zm12.172,0a2.946,2.946,0,0,0-1.561.514,5.864,5.864,0,0,1-.529,5.376,2.778,2.778,0,0,0,.715.592l2.619,1.209a2.189,2.189,0,0,1,1.217,1.954v3.319h2.8A.715.715,0,0,0,24,19.341V16.2a.733.733,0,0,0-.423-.72L19.528,13.6a3.735,3.735,0,0,0,1.587-3.035,3.8,3.8,0,0,0-.887-2.418,2.986,2.986,0,0,0-2.157-1Z",
    transform: "translate(0 -5.655)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.fbdf5ba3f5c95b3a780120d9091b594f.svg";
export { ForwardRef as ReactComponent };